import { useGetSetupUrl } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";
import { Navigate } from "react-router";
import { useProjectTenantView } from "./ProjectTenantProvider.tsx";

export function ProjectTenantGate({ children }: PropsWithChildren) {
    const view = useProjectTenantView();
    const consentRedirectUrl = useGetSetupUrl("migrateAssessment");

    if (view === "associating") {
        return null;
    }

    if (view === "redirect") {
        return <Navigate to={consentRedirectUrl} replace />;
    }

    return children;
}
